import { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";

export default function TAdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/tenant/dashboard").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-neutral-500">Loading…</div>;
  const { stats, recent_bookings } = data;

  const cards = [
    { k: "total_bookings", l: "Total bookings" },
    { k: "pending", l: "Pending" },
    { k: "completed", l: "Completed" },
    { k: "cancelled", l: "Cancelled" },
    { k: "total_enquiries", l: "Enquiries" },
    { k: "new_enquiries", l: "New enquiries" },
    { k: "services", l: "Services" },
    { k: "sellers", l: "Sellers" },
  ];

  return (
    <div data-testid="tadmin-dashboard">
      <div className="flex flex-wrap justify-between items-end gap-4 mb-6 sm:mb-8">
        <div>
          <div className="admin-overline">Overview</div>
          <h1 className="admin-heading text-3xl sm:text-4xl font-bold tracking-tight mt-1">Today's pulse.</h1>
        </div>
        <div className="sm:text-right">
          <div className="admin-overline">Revenue</div>
          <div className="admin-heading text-3xl font-bold">{formatINR(stats.revenue)}</div>
        </div>
      </div>

      <div className="stat-grid">
        {cards.map((c) => (
          <div key={c.k} data-testid={`tadmin-stat-${c.k}`}>
            <div className="admin-overline">{c.l}</div>
            <div className="admin-heading text-2xl sm:text-3xl font-bold mt-1">{stats[c.k] ?? 0}</div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-neutral-200 mt-6 sm:mt-8 p-4 sm:p-6">
        <div className="admin-overline mb-4">Recent bookings</div>
        <div className="table-scroll">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-neutral-500 border-b border-neutral-200">
            <th className="py-2">Code</th><th>Service</th><th>Customer</th><th>Date</th><th>Status</th><th className="text-right">Total</th>
          </tr></thead>
          <tbody>
            {recent_bookings.length === 0 && <tr><td colSpan="6" className="py-6 text-center text-neutral-500">No bookings yet</td></tr>}
            {recent_bookings.map((b) => (
              <tr key={b.id} className="border-b border-neutral-100">
                <td className="py-2 font-mono text-xs">{b.code}</td>
                <td>{b.service_name}</td>
                <td>{b.customer_name}</td>
                <td className="text-xs">{b.scheduled_date} {b.scheduled_slot}</td>
                <td><span className="text-xs uppercase">{b.status}</span></td>
                <td className="text-right font-bold">{formatINR(b.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
